module.exports = __webpack_public_path__ + "static/media/btn-arrow-right.12e2818b.png";